import React, { useEffect, useState } from "react";
import { Modal, Confirm } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Table } from "semantic-ui-react";
import { assignUnassLead, getLeadUn, getCommentsUn } from "../leads/leadActions";
import { closeModal } from "../../app/common/modals/modalReducer";
import LeadDetailedComments from "../leads/LeadDetailed/LeadDetailedComments";
import { format } from "date-fns";

import firebase from "../../app/config/firebase";
const firestore = firebase.firestore();

export default function LeadUnassViewModal(props) {
    const dispatch = useDispatch();
    let lead = props.lead;
    console.log('lead ---- ', lead);
    let cfdb = [];
    let leadDate = lead.cfdb;
    const [leads_dup2, setLeads_dup2] = useState([]);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const { currentUserProfile } = useSelector((state) => state.profile);
    const sanitize = (val) => (val || "").trim().toLowerCase().replace(/\s+/g, "");
    // Common placeholders that can cause massive false-positive duplicate matches.
    const INVALID_PHONES = new Set(["tba", "unknown", "0000000000", "n/a", "", "0", "none", "-", "na"]);
    const MAX_PREVIEW = 140;
    const isHashLike = (value) => typeof value === "string" && /^[a-f0-9]{32,64}$/i.test(value);
    const hiddenKeyPatterns = [/^wh_/i, /^pys_/i, /^utm_/i, /^fbp$/i, /^fbc$/i];
    const hasHtmlTags = (value) => {
        if (typeof value !== "string") return false;
        return /<[^>]+>/.test(value) || /&lt;[^&]+&gt;/.test(value);
    };
    const isJsonLikeString = (value) => {
        if (typeof value !== "string") return false;
        const trimmed = value.trim();
        if (!trimmed) return false;
        if (
            (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"))
        ) {
            try {
                JSON.parse(trimmed);
                return true;
            } catch (error) {
                return false;
            }
        }
        return false;
    };
    const isJsonValue = (value) => {
        if (Array.isArray(value)) return true;
        if (value && typeof value === "object" && !(value instanceof Date) && !(value?.toDate && typeof value.toDate === "function")) {
            return true;
        }
        return isJsonLikeString(value);
    };
    const shouldHideValue = (key, value) => {
        const keyText = (key || "").toString();
        if (hiddenKeyPatterns.some((pattern) => pattern.test(keyText))) return true;
        if (isJsonValue(value)) return true;
        if (hasHtmlTags(value)) return true;
        if (isHashLike(value)) return true;
        return false;
    };
    const buildDisplay = (value) => {
        if (value === null || value === undefined) return { text: "-", isMuted: true };
        if (typeof value === "string") {
            const trimmed = value.trim();
            if (!trimmed) return { text: "-", isMuted: true };
            if (isHashLike(trimmed)) {
                return { text: `hash:${trimmed.slice(0, 8)}...`, fullText: trimmed, isMuted: true };
            }
            if (trimmed.length > MAX_PREVIEW) {
                return { text: `${trimmed.slice(0, MAX_PREVIEW)}...`, fullText: trimmed };
            }
            return { text: trimmed };
        }
        if (typeof value === "number" || typeof value === "boolean") return { text: String(value) };
        if (value instanceof Date) return { text: format(value, "dd MMM yyyy") };
        if (value?.toDate && typeof value.toDate === "function") {
            try {
                return { text: format(value.toDate(), "dd MMM yyyy") };
            } catch (error) {
                return { text: String(value.toDate()) };
            }
        }
        if (Array.isArray(value)) {
            if (value.length === 0) return { text: "-", isMuted: true };
            return { text: value.map((item) => String(item)).join(", ") };
        }
        return { text: String(value) };
    };
    const renderCellValue = (key, value) => {
        if (shouldHideValue(key, value)) return null;
        const display = buildDisplay(value);
        const commonStyle = {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxWidth: "520px",
        };
        const title = display.fullText || display.text;
        return (
            <span style={{ ...commonStyle, color: display.isMuted ? "#888" : undefined }} title={title}>
                {display.text}
            </span>
        );
    };

    useEffect(() => {
        const checkDuplicates = async () => {
            const sanitizedEmail = sanitize(lead.client_email);
            let sanitizedPhone = sanitize(lead.client_phone);
            if (INVALID_PHONES.has(sanitizedPhone)) sanitizedPhone = "";

            const filters = [];
            if (!sanitizedEmail && !sanitizedPhone) return;

            try {
                const emailQuery = sanitizedEmail
                    ? firestore.collection("leads").where("client_email", "==", sanitizedEmail).get()
                    : Promise.resolve({ docs: [] });

                const phoneQuery = sanitizedPhone
                    ? firestore.collection("leads").where("client_phone", "==", sanitizedPhone).get()
                    : Promise.resolve({ docs: [] });

                const [emailSnap, phoneSnap] = await Promise.all([emailQuery, phoneQuery]);

                const seen = new Set();
                const list = [];

                [...emailSnap.docs, ...phoneSnap.docs].forEach((doc) => {
                    const data = doc.data();
                    if (data.status !== "Unassigned" && data.status !== "Archived" && !seen.has(doc.id)) {
                        seen.add(doc.id);
                        list.push({ ...data, id: doc.id });
                    }
                });
                setLeads_dup2(list);
            } catch (error) {
                console.error("Error checking duplicates:", error);
            }
        };

        checkDuplicates();
    }, [lead.client_email, lead.client_phone]);

    let includes = [
        "travel_from_date",
        "travel_to_date",
        "dates_flexible",
        "adults",
        "children",
        "child_1",
        "child_2",
        "child_3",
        "child_4",
        "child_5",
        "child_6",
        "departing_from",
        "estimated_budget",
        "anything_else",
        "client_name",
        "client_surname",
        "client_email",
        "client_phone",
        "customer_note",
        "form_title",
        "where_go",
        "children_age",
        "privacy_consent",
        "entry_date",
        "source_url",
        "your_message",
        "wh_fb_campaign",
        "wh_query_string",
        "wh_referer_first",
        "wh_referer_last",
        "wh_referer_time",
    ];

    if (lead.form_name === "Woocommerce" || lead.form_name === "Quote Basket") {
        if (lead.cfdb.meta_data) {
            //Per website Form
            cfdb.push({ key: "Travel date (from)", value: lead.cfdb.meta_data[0].value });
            cfdb.push({ key: "Travel date (to)", value: lead.cfdb.meta_data[1].value });
            cfdb.push({ key: "Flexible dates", value: lead.cfdb.meta_data[2].value });
            cfdb.push({ key: "Adults", value: lead.cfdb.meta_data[3].value });

            cfdb.push({ key: "Children", value: lead.cfdb.meta_data ? lead.cfdb.meta_data[4].value : "" });
            cfdb.push({ key: "Child 1 Age", value: lead.cfdb.meta_data && lead.cfdb.meta_data[5] ? lead.cfdb.meta_data[5].value : "" });
            cfdb.push({ key: "Child 2 Age", value: lead.cfdb.meta_data && lead.cfdb.meta_data[6] ? lead.cfdb.meta_data[6].value : "" });
            cfdb.push({ key: "Child 3 Age", value: lead.cfdb.meta_data && lead.cfdb.meta_data[7] ? lead.cfdb.meta_data[7].value : "" });
            cfdb.push({ key: "Child 4 Age", value: lead.cfdb.meta_data && lead.cfdb.meta_data[8] ? lead.cfdb.meta_data[8].value : "" });
            cfdb.push({ key: "Child 5 Age", value: lead.cfdb.meta_data && lead.cfdb.meta_data[9] ? lead.cfdb.meta_data[9].value : "" });
            cfdb.push({ key: "Child 6 Age", value: lead.cfdb.meta_data && lead.cfdb.meta_data[10] ? lead.cfdb.meta_data[10].value : "" });
            cfdb.push({ key: "Departing from", value: lead.cfdb.meta_data && lead.cfdb.meta_data[11] ? lead.cfdb.meta_data[11].value : "" });
            cfdb.push({ key: "Customer Note", value: lead.cfdb.customer_note ? lead.cfdb.customer_note : "" });
            // cfdb.push({ key: "Estimated budget", value: "MISSING" });
            // cfdb.push({ key: "Additional info", value: "MISSING" });

            cfdb.push({ key: "First name", value: lead.cfdb.billing.first_name });
            cfdb.push({ key: "Last Name", value: lead.cfdb.billing.last_name });
            cfdb.push({ key: "Email Address", value: lead.cfdb.billing.email });
            cfdb.push({ key: "Contact phone", value: lead.cfdb.billing.phone });

            //Session tracking data
            cfdb.push({ key: "wh_referer_first", value: lead.cfdb.billing ? lead.cfdb.billing.wh_referer_first : "" });
            cfdb.push({ key: "wh_referer_last", value: lead.cfdb.billing ? lead.cfdb.billing.wh_referer_last : "" });
            cfdb.push({ key: "wh_query_string", value: lead.cfdb.billing ? lead.cfdb.billing.wh_query_string : "" });
            cfdb.push({ key: "wh_referer_time", value: lead.cfdb.billing ? lead.cfdb.billing.wh_referer_time : "" });
            cfdb.push({ key: "wh_fb_campaign", value: lead.cfdb.billing ? lead.cfdb.billing.wh_fb_campaign : "" });

            Object.keys(lead.cfdb.line_items).forEach(function (key) {
                cfdb.push({
                    key: "name",
                    value: lead.cfdb.line_items[key].name,
                });
                cfdb.push({
                    key: "total",
                    value: lead.cfdb.line_items[key].subtotal,
                });
            });
        } else {
            const cfdbObj = JSON.parse(lead.cfdb[0].field_value);
            cfdb.push({ key: "Travel date (from)", value: cfdbObj.meta_data[0].value });
            cfdb.push({ key: "Travel date (to)", value: cfdbObj.meta_data[1].value });
            cfdb.push({ key: "Flexible dates", value: cfdbObj.meta_data[2].value });
            cfdb.push({ key: "Adults", value: cfdbObj.meta_data[3].value });


            cfdb.push({ key: "Children", value: cfdbObj.meta_data ? cfdbObj.meta_data[4].value : "" });
            cfdb.push({ key: "Child 1 Age", value: cfdbObj.meta_data && cfdbObj.meta_data[5] ? cfdbObj.meta_data[5].value : "" });
            cfdb.push({ key: "Child 2 Age", value: cfdbObj.meta_data && cfdbObj.meta_data[6] ? cfdbObj.meta_data[6].value : "" });
            cfdb.push({ key: "Child 3 Age", value: cfdbObj.meta_data && cfdbObj.meta_data[7] ? cfdbObj.meta_data[7].value : "" });
            cfdb.push({ key: "Child 4 Age", value: cfdbObj.meta_data && cfdbObj.meta_data[8] ? cfdbObj.meta_data[8].value : "" });
            cfdb.push({ key: "Child 5 Age", value: cfdbObj.meta_data && cfdbObj.meta_data[9] ? cfdbObj.meta_data[9].value : "" });
            cfdb.push({ key: "Child 6 Age", value: cfdbObj.meta_data && cfdbObj.meta_data[10] ? cfdbObj.meta_data[10].value : "" });
            cfdb.push({ key: "Departing from", value: cfdbObj.meta_data && cfdbObj.meta_data[11] ? cfdbObj.meta_data[11].value : "" });

            cfdb.push({ key: "Customer Note", value: cfdbObj.customer_note ? cfdbObj.customer_note : "" });

            cfdb.push({ key: "First name", value: cfdbObj.billing.first_name });
            cfdb.push({ key: "Last Name", value: cfdbObj.billing.last_name });
            cfdb.push({ key: "Email Address", value: cfdbObj.billing.email });
            cfdb.push({ key: "Contact phone", value: cfdbObj.billing.phone });

            //Session tracking data
            cfdb.push({ key: "wh_referer_first", value: cfdbObj.billing ? cfdbObj.billing.wh_referer_first : "" });
            cfdb.push({ key: "wh_referer_last", value: cfdbObj.billing ? cfdbObj.billing.wh_referer_last : "" });
            cfdb.push({ key: "wh_query_string", value: cfdbObj.billing ? cfdbObj.billing.wh_query_string : "" });
            cfdb.push({ key: "wh_referer_time", value: cfdbObj.billing ? cfdbObj.billing.wh_referer_time : "" });
            cfdb.push({ key: "wh_fb_campaign", value: cfdbObj.billing ? cfdbObj.billing.wh_fb_campaign : "" });

            Object.keys(cfdbObj.line_items).forEach(function (key) {
                cfdb.push({
                    key: "Quantity",
                    value: cfdbObj.line_items[key].quantity,
                });
                cfdb.push({
                    key: "name",
                    value: cfdbObj.line_items[key].name,
                });
                cfdb.push({
                    key: "total",
                    value: cfdbObj.line_items[key].subtotal,
                });

            });
        }
    } else if (lead.form_name !== "Unsure") {
        if (leadDate !== undefined) {
            if (leadDate[0] !== undefined && leadDate[0].field_name === "original_data") {
                let originalArr = JSON.parse(leadDate[0].field_value);

                cfdb.push({ key: "Travel date (from)", value: originalArr[14] });
                cfdb.push({ key: "Travel date (to)", value: originalArr[15] });
                cfdb.push({ key: "Flexible dates", value: originalArr[13] });

                cfdb.push({ key: "Departing from", value: originalArr[21] });
                cfdb.push({ key: "Estimated budget", value: originalArr[22] });

                cfdb.push({ key: "First name", value: originalArr[1] });
                cfdb.push({ key: "Last Name", value: originalArr[8] });
                cfdb.push({ key: "Email Address", value: originalArr[3] });
                cfdb.push({ key: "Contact phone", value: originalArr[9] });
            } else {
                var i;
                for (i = 0; i < includes.length; i++) {
                    // eslint-disable-next-line no-loop-func
                    Object.keys(leadDate).forEach(function (key) {
                        if (key == includes[i]) {
                            cfdb.push({
                                key: key,
                                value: lead.cfdb[key],
                            });
                        }
                    });
                }
            }
        }
    }

    if (lead.form_name === "Manual Add") {
        cfdb.push({ key: "Client Email", value: lead.client_email });
        cfdb.push({ key: "Client Name", value: lead.client_name });
        cfdb.push({ key: "Client Phone", value: lead.client_phone });
        cfdb.push({ key: "Departing From", value: lead.departing_from });
        cfdb.push({ key: "Destination", value: lead.destination });
        cfdb.push({ key: "Enquiry Source", value: lead.enquiry_source });
        cfdb.push({ key: "Enquiry Source Other", value: lead.enquiry_source_other });
        cfdb.push({ key: "Number of Travellers", value: lead.number_travellers });
        cfdb.push({ key: "Package", value: lead.package });

        if (lead.travel_date_from && lead.travel_date_from !== "") {
            cfdb.push({ key: "Travel Date From", value: format(lead.travel_date_from.toDate(), "dd-MMM-yyyy") });
        }
        if (lead.travel_date && lead.travel_date !== "") {
            cfdb.push({ key: "Travel Date To", value: format(lead.travel_date.toDate(), "dd-MMM-yyyy") });
        }

        cfdb.push({ key: "Comments", value: lead.unassigned_comments });
        cfdb.push({ key: "Website Division", value: lead.website_division });
        cfdb.push({ key: "Website Source", value: lead.website_source });
    }

    async function AssignLead(lead) {
        await assignUnassLead(lead, currentUserProfile);
        dispatch(closeModal());
    }

    async function archiveLeadHere(lead) {
        setDeleteOpen(false);
        setDeleting(true);
        try {
            await firestore.collection("leads").doc(lead.id).update({
                status: "Archived",
                archived: true,
                archivedOn: new Date(Date.now()),
            });
        } finally {
            setDeleting(false);
        }
        dispatch(closeModal());
    }

    return (
        <>
            <Modal size="large" open={true} onClose={() => dispatch(closeModal())} closeOnDimmerClick={false}>
                <Modal.Header>Lead Details</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {leadDate && leadDate.length > 0 && leadDate.meta_data !== undefined && (
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign="center" colSpan={2}>
                                            Lead Data
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {leadDate
                                        .filter((c) => !shouldHideValue(c.key, c.value))
                                        .map((c, index) => (
                                        <Table.Row key={`${c.key || "lead"}-${index}`}>
                                            <Table.Cell>{c.key}</Table.Cell>
                                            <Table.Cell>{renderCellValue(c.key, c.value)}</Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        )}

                        {cfdb && cfdb.length > 0 && (
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign="center" colSpan={2}>
                                            Website Data
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {cfdb
                                        .filter((c) => !shouldHideValue(c?.key, c?.value))
                                        .map((c, index) => {
                                        console.log('c ---- ', c);
                                        return (
                                            <Table.Row key={`${c?.key || "cfdb"}-${index}`}>
                                                <Table.Cell>{c?.key}</Table.Cell>
                                                <Table.Cell>{renderCellValue(c?.key, c?.value)}</Table.Cell>
                                            </Table.Row>
                                        )
                                    })}
                                </Table.Body>
                            </Table>
                        )}
                        {leads_dup2 && leads_dup2.length > 0 && (
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign="center" colSpan={3}>
                                            Duplicates
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell>Created On</Table.HeaderCell>
                                        <Table.HeaderCell>Assigned To</Table.HeaderCell>
                                        <Table.HeaderCell>Actions</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {leads_dup2.map((ld) => (
                                        <Table.Row key={ld.id}>
                                            <Table.Cell>
                                                {ld.assignDate && ld.assignDate !== ""
                                                    ? format(ld.assignDate.toDate(), "dd MMM yyyy HH:mm a")
                                                    : ld.createDate && ld.createDate !== ""
                                                        ? format(ld.createDate.toDate(), "dd MMM yyyy HH:mm a")
                                                        : ""}
                                            </Table.Cell>
                                            <Table.Cell>{ld.userDisplayName}</Table.Cell>
                                            <Table.Cell>
                                                <a target="_blank" href={`/leads/edit/${ld.id}`}>
                                                    View
                                                </a>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        )}

                        <LeadDetailedComments lead={lead} />
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    {currentUserProfile?.isAdmin === true && (
                        <>
                            <Button color="red" onClick={() => setDeleteOpen(true)} loading={deleting} disabled={deleting}>
                                Archive
                            </Button>
                            <Confirm
                                header="You are about to archive this lead"
                                content="This will remove it from active lists. Continue?"
                                size="tiny"
                                open={deleteOpen}
                                onCancel={() => setDeleteOpen(false)}
                                onConfirm={() => archiveLeadHere(lead)}
                                confirmButton="Yes"
                            />
                        </>
                    )}
                    <Button color="orange" onClick={() => AssignLead(lead)}>
                        Assign Lead
                    </Button>
                    <Button onClick={() => dispatch(closeModal())}>Cancel</Button>
                </Modal.Actions>
            </Modal>
        </>
    );
}
